import _ from "lodash"

import getAllTiposIndicador from 'entity/TipoIndicador/all'

const validationColetasVazias = async (values) => {
    for (const TipoClass of getAllTiposIndicador()) {
        for (const Indicador of TipoClass.indicadores) {
            let indicador = _.get(values.apontamentos, `${TipoClass.field}.${Indicador.field}`)

            if (indicador)
                for (let i = 0; i < indicador.length; i++)
                    for (let j = 0; j < indicador[i].pontosColetas?.length; j++)
                        for (let k = 0; k < indicador[i].pontosColetas[j].coletas?.length; k++)
                            if (!indicador[i].pontosColetas[j].coletas[k].valor)
                                return `Coleta vazia: ${TipoClass.fullName} / ${i + 1}º ${Indicador.fullName}`
        }
    }

    return null
}

export const validationLaudoVisita = async (values) => {
    if (!values.fazenda)
        return ["Informe a fazenda"]

    if (!values.safra)
        return ["Informe a safra"]

    if (!values.cultura)
        return ["Informe a cultura"]

    let validAux = await validationColetasVazias(values)
    if (validAux)
        return validAux

    return null
}

function getRandomColor() {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
    }
    return color
}

const createArrExtraGraphData = (labelArr) => {
    let objArr = []
    for (let i = 0; i < labelArr.length; i++) {
        objArr.push({
            label: labelArr[i].label,
            field: labelArr[i].field,
            sum: 0,
            avg: 0,
            percentage: 0,
            color: getRandomColor()
        })
    }
    return objArr
}

export const getExtraGraphDataArr = (indicadorProps) => {

    let extraGraphDataArr = []
    let total = 0
    // console.log('indicadorProps', indicadorProps)
    extraGraphDataArr = createArrExtraGraphData([
        { label: 'Toco', field: 'toco' },
        { label: 'Ponteiro', field: 'ponteiro' },
        { label: 'Inteira', field: 'canaInteira' },
        { label: 'Pedaço Fixo', field: 'canaFixa' },
        { label: 'Estilhaço', field: 'estilhaco' },
        { label: 'Tolete', field: 'tolete' },
        { label: 'Pedaço', field: 'pedaco' },
        { label: 'Lasca', field: 'lasca' },
        { label: 'Tolete Estilhaçado', field: 'toleteEstilhacado' },
    ])

    let aptsLength = indicadorProps.apontamentos.length

    for (let i = 0; i < aptsLength; i++) {
        for (let j = 0; j < extraGraphDataArr.length; j++) {
            extraGraphDataArr[j].sum += parseFloat(_.get(indicadorProps.apontamentos[i], extraGraphDataArr[j].field, 0)) || 0
        }
    }

    for (let i = 0; i < extraGraphDataArr.length; i++) {
        // if(i === 0) {
        //     console.log('avg')
        //     console.log(`${extraGraphDataArr[i].sum} /`)
        // }
        extraGraphDataArr[i].avg = extraGraphDataArr[i].sum / aptsLength
        total += extraGraphDataArr[i].avg
    }

    for (let i = 0; i < extraGraphDataArr.length; i++) {
        extraGraphDataArr[i].percentage = parseFloat((extraGraphDataArr[i].avg * 100) / total)
    }

    // console.log('extraGraphDataArr', extraGraphDataArr)

    return extraGraphDataArr.filter(d => d.percentage > 0)
}